import { KeyValueObj } from "@/common/types";

// A level reduced to what identifies it: its type, and how many of the level
// below it holds.
type NormalisedLayer = [string, number | null];

// Mirrors Product#packaging_hierarchy_differs_from? in medex-backend — the type
// is compared case-insensitively, and a containment of 1 counts as none (the
// base unit holds no child). Kept in step with that method by hand; the API
// remains the authority and refuses any purge the SPA failed to predict.
function normalise(layers?: KeyValueObj[]): NormalisedLayer[] {
  return (Array.isArray(layers) ? layers : []).map((layer) => {
    const type = String(layer?.packaging_type ?? "")
      .trim()
      .toLowerCase();
    const raw = layer?.containment_quantity;
    // Truncated because the Ruby side casts with `to_i`: without this, a typed
    // "2.5" would read as a change here and as none there.
    const numeric = Math.trunc(Number(raw));
    const quantity =
      raw === undefined || raw === null || raw === "" || numeric === 1
        ? null
        : numeric;
    return [type, quantity];
  });
}

// True when `submitted` describes a different packaging hierarchy than
// `persisted`. Submitting no layers is not a change: the API leaves the stored
// hierarchy alone when the parameter is absent.
export function packagingHierarchyChanged(
  submitted?: KeyValueObj[],
  persisted?: KeyValueObj[],
): boolean {
  if (!Array.isArray(submitted) || submitted.length === 0) return false;

  const submittedLayers = normalise(submitted);
  const persistedLayers = normalise(persisted);

  if (submittedLayers.length !== persistedLayers.length) return true;

  return submittedLayers.some(
    ([type, quantity], index) =>
      type !== persistedLayers[index][0] ||
      quantity !== persistedLayers[index][1],
  );
}
